module.exports = __webpack_public_path__ + "media/images/avatar/05-5605a6b759e4be1aadc0b6502667004b.jpg";